
export const APP_ENV = process.env.REACT_APP_ENV;

export const IMAGE_COMPRESSION_MAX_SIZE_MB = 2;  // max file size limit in MB


//
export const LATE_DELIVERY_APPEAL_TYPE = "LateDelivery";
export const LATE_DELIVERY_APPEAL_MESSAGE = "The delivery is overdue, I would like a refund.";
//
export const STAGE_OFFER_ACCEPTED = "Offer Accepted";

export const ELEMENT_IDS = {
    BTN_SIGN_UP_FROM_LP: "sign-up-from-LP",
    BTN_LOG_IN_FROM_LP: "log-in-from-LP",
};

export const MODAL_IDS = {
    SIGN_UP: "signUpModal",
    LOG_IN: "logInModal",
    //
    VIEW_OFFER: "view-offer-modal",
    DENY_OFFER: "deny-offer-modal",
    ACCEPT_OFFER: "accept-offer-modal",
};


// initialFields
export const INITIAL_FIELDS = {
    signUpAsBrand: [
        {
            key: "brand_name",
            type: "text",
            value: "",
            error: "",
            placeholder: "Enter brand name",
            label: "Brand Name",
            required: true,
        },
        {
            key: "email",
            type: "email",
            value: "",
            error: "",
            placeholder: "Enter brand email",
            label: "Brand Email",
            required: true,
        },
        {
            key: "company_address",
            type: "text",
            value: "",
            error: "",
            placeholder: "Company Address*",
            label: "Company Address",
            required: true,
        },
        {
            key: "contact_details",
            type: "text",
            value: "",
            error: "",
            placeholder: "Contact No*",
            label: "Phone",
            required: true,

        },
        {
            key: "password",
            type: "password",
            value: "",
            error: "",
            placeholder: "Enter Password*",
            label: "Password",
            required: true,
        },
        {
            key: "password_confirmation",
            type: "password",
            value: "",
            error: "",
            placeholder: "Confirm Password*",
            label: "Confirm Password",
            required: true,
        },
    ],
    signUpAsCreator: [
        {
            type: "text",
            key: "profile_name",
            value: "",
            error: "",
            // placeholder: "Full Name*",
            placeholder: "Enter full name*",
            label: "Full Name",
            required: true,
        },
        {
            type: "date",
            key: "date_of_birth",
            value: "",
            error: "",
            placeholder: "Date of Birth",
            helperText: "Enter your date of birth", // check here
            label: "Date of Birth",
            required: true,
        },
        {
            type: "text",
            key: "address",
            value: "",
            error: "",
            placeholder: "Enter address*",
            label: "Current Address",
            required: true,
        },
        {
            type: "email",
            key: "email",
            value: "",
            error: "",
            placeholder: "Enter your email*",
            label: "E-mail",
            required: true,
        },
        {
            type: "tel",
            key: "phone_number",
            value: "",
            error: "",
            placeholder: "Phone No*",
            label: "Phone",
            required: true,
        },
        {
            type: "select",
            key: "gender",
            value: "",
            error: "",
            placeholder: "Select Gender*",
            options: ["Male", "Female", "Other"],
            label: "Select Gender",
            required: true,

        },
        {
            key: "password",
            type: "password",
            value: "",
            error: "",
            placeholder: "Enter Password*",
            label: "Password",
            required: true,
        },
        {
            key: "password_confirmation",
            type: "password",
            value: "",
            error: "",
            placeholder: "Confirm Password*",
            label: "Confirm Password",
            required: true,
        },
    ],
    logInFields: [
        {
            type: "email",
            key: "email",
            value: "",
            error: "",
            placeholder: "Email",
            label: "Email",
            required: true,
            helperTextBottom: "We'll never share your email with anyone else." // check here
        },
        {
            type: "password",
            key: "password",
            value: "",
            error: "",
            placeholder: "Password",
            label: "Password",
            required: true,
        },
    ],
    forgotPassFields: [
        {
            type: "email",
            key: "email",
            value: "",
            error: "",
            placeholder: "Email*",
        },
    ],
};


export const CATEGORIES = {
    lifestyle: [
        "Lifestyle",
        "Travel",
        "Pets",
        "Causes",
        "Decor",
        "Family",
        "Wedding",
        "Dogs",
        "Cats",
        "Environmentalism",
        "Garden",
        "Home",
    ],
    arts: [
        "Arts",
        "Crafts",
        "Graffiti",
        "Tattoo",
        "Painting",
        "Sculpture",
        "Photography",
        "DIY",
        "Cats",
        "Handmade",
        "Scrapbooking",
    ],
    beauty: [
        "Fashion",
        "Beauty",
        "Beachwear",
        "Boutique",
        "Menswear",
        "Models",
        "Plus Size",
        "Showroom",
        "Streetwear",
        "Stylist",
        "Lingerie",
        "Makeup",
        "Nails",
        "Lashes",
        "Hairstyling",
        "Skincare",
        "Beautysalon",
        "Barber",
    ],
    health: [
        "Food",
        "Health",
        "Craftbeer",
        "Bakery",
        "Restaurant",
        "Chef",
        "Veganism",
        "Spirituality",
        "Nutrition",
        "Wellness",
        "Meditation",
        "Relaxation",
        "Motivational",
    ],
    sport: [
        "Sport",
        "Fitness",
        "Karate",
        "Boxing",
        "JiuJitsu",
        "Judo",
        "MMA",
        "Wrestling",
        "Running",
        "Athletics",
        "Cycling",
        "Gymnastics",
        "Olympian",
        "Climbing",
        "Diving",
        "Rowing",
        "Skating",
        "Skiing",
        "Tennis",
        "Badminton",
        "Basketball",
        "Cricket",
        "Golf",
        "Handball",
        "Hockey",
    ],
    tech: ["Business", "Tech", "Entrepreneur", "Cars"],
    music: [
        "Music",
        "Media",
        "Cinema",
        "Acting",
        "DJ",
        "Hip-hop",
        "Guitar",
        "Piano",
        "Violin",
        "Singer",
        "Instrumentalist",
        "Songwriter",
        "Music Composer",
        "Dancer",
        "Journalist",
        "Radio",
        "Theater",
    ],
    games: ["Culture", "Games", "Comicbooks"],
};


export const locationData = [
    "New York, USA",
    "Berlin, Germany",
    "Hankok, Germany",
    "London, UK",
    "Media City, UK",
    "Islamabad, Pakistan",
    "Lahore,Pakistan",
  ];
